import { GlobalStyles } from '@mui/material';

/**
 * While a drag is active the whole page shows `grabbing` - the handle, the body and whatever is under
 * the pointer (DB-12b). Rendered only for the length of the drag, so the cursor is restored on drop and
 * on cancel without any cleanup.
 */
export function DragCursor({ active }: { active: boolean }) {
  return active ? <GlobalStyles styles={{ 'html, body, body *': { cursor: 'grabbing !important' } }} /> : null;
}
